import { render } from "./CreateOrder.vue?vue&type=template&id=9a244bb4&scoped=true"
import script from "./CreateOrder.vue?vue&type=script&lang=js"
export * from "./CreateOrder.vue?vue&type=script&lang=js"

import "./CreateOrder.vue?vue&type=style&index=0&id=9a244bb4&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-9a244bb4"

export default script